import * as React from "react";
import { IoHeart } from "@react-icons/all-files/io5/IoHeart";
import { IoShareSocial } from "@react-icons/all-files/io5/IoShareSocial";
import { invoke } from "@kalabo/golfsavers-common";
import Facebook_Icon from "@images/icons/facebook.svg";
import Twitter_Icon from "@images/icons/twitter.svg";
import Linkedin_Icon from "@images/icons/linkedin.svg";
import Messenger_Icon from "@images/icons/messenger.svg";
import Whatsapp_Icon from "@images/icons/whatsapp.svg";
import Line_Icon from "@images/icons/line.svg";
import Copy_Icon from "@images/icons/copy.svg";
import Mail_Icon from "@images/icons/mail.svg";
import Modal from "../modal";
import useUser from "@hooks/useUser";
import { Text } from "@uikit";
import { notification } from "antd";
import { Link } from "gatsby";
import { useApp } from "@store/app";
import { useWindow } from "@hooks/useWindow";
import { useAuth } from "@store/auth";

interface IProps {
  value: string;
  name: string;
}

const LikeShare = ({ value, name }: IProps) => {
  const userProfile = useAuth(($) => $.userProfile);
  const refreshUser = useAuth(($) => $.refreshUser);
  const win = useWindow();

  const setShowLoginModal = useApp(($) => $.setShowLoginModal);

  const [shareVisible, setShareVisible] = React.useState(false);
  const [isCopied, setIsCopied] = React.useState(false);

  const updateUserLike = React.useCallback(async () => {
    let response = await invoke("toggleUserFav", {
      user_id: userProfile?.id,
      value: value,
    });
    if (response.status !== 200) {
      return;
    }
    return response;
  }, [userProfile, value]);

  const toggleLike = React.useCallback(async () => {
    let adding = true;
    let isUserProfileNullOrEmpty =
      !userProfile || JSON.stringify(userProfile) === "{}";

    if (isUserProfileNullOrEmpty) {
      setShowLoginModal();
    } else {
      if (userProfile?.user_favourites?.includes(value)) {
        adding = false;
      }
      await updateUserLike();
      await refreshUser(userProfile?.email);
      notification.success({
        message: (
          <Text
            size={15}
            sizeDesktop={17}
            sizeTablet={17}
            leading={1.3}
            weight="semibold"
            color="black"
          >
            Success
          </Text>
        ),
        description: adding ? (
          <>
            Added {name} to your{" "}
            <Link to="/account/favourites" className="underline font-semibold">
              favourites list
            </Link>
          </>
        ) : (
          <>
            Removed {name} from your{" "}
            <Link to="/account/favourites" className="underline font-semibold">
              favourites list
            </Link>
          </>
        ),
        onClick: () => {},
      });
    }
  }, [userProfile, name, value]);

  const isLiked = React.useMemo(() => {
    // does the value exist in the user.user_favourites array?
    if (!userProfile) return false;
    return userProfile?.user_favourites?.includes(value);
  }, [userProfile, value]);

  return (
    <>
      <Modal
        pinnedMode
        visible={shareVisible}
        maxWidth="560px"
        title={"Share this course"}
        onClose={() => {
          setIsCopied(false);
          setShareVisible(false);
        }}
      >
        <div className="grid grid-cols-12  gap-5 px-5 pt-7 pb-12 w-full">
          <div className="col-span-6 flex gap-5 flex-col ">
            <div
              className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center"
              onClick={() => {
                notification.success({
                  message: "Added to clipboard",
                  duration: 2,
                });
                if (win) navigator.clipboard.writeText(window.location.href);
              }}
            >
              <Copy_Icon />
              Copy Link
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Facebook_Icon />
              Facebook
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Whatsapp_Icon />
              Whatsapp
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Twitter_Icon />
              Twitter
            </div>
          </div>
          <div className="col-span-6 flex gap-5 flex-col ">
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Mail_Icon />
              Email
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Messenger_Icon />
              Messenger
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Line_Icon />
              Line
            </div>
            <div className="border cursor-pointer border-grey3 p-4 rounded-[4px] flex gap-2 items-center">
              <Linkedin_Icon />
              Linkedin
            </div>
          </div>
        </div>
      </Modal>
      <div className="flex gap-2">
        <div
          className={`shadow-lg sm:shadow-none sm:border w-9 h-9 items-center flex justify-center rounded-full cursor-pointer ${
            isLiked
              ? "bg-lightred border-lightred"
              : "bg-white hover:bg-grey2 border-grey7"
          }`}
          onClick={() => {
            toggleLike();
          }}
        >
          <IoHeart
            className={`h-4 w-4  inline items-center ${
              isLiked ? "text-white" : "text-grey7"
            }`}
            aria-hidden="true"
          />
        </div>
        <div
          className="shadow-lg sm:shadow-none sm:border w-9 h-9 items-center flex justify-center rounded-full border-grey7 bg-white hover:bg-grey2 cursor-pointer"
          onClick={() => {
            setShareVisible(true);
          }}
        >
          <IoShareSocial
            className="h-4 w-4  text-grey7 inline items-center"
            aria-hidden="true"
          />
        </div>
      </div>
    </>
  );
};

export default LikeShare;
